import { type } from 'os';
import i18n from '../i18n';
import moment from "moment";

class Formatter {
  /**
   * Formatear números con cantidad de decimales y puntuación de miles.
   * En caso de no ser número, devuelve un error como excepción, si cualquier
   * otro error sucede devuelve un string vacio.
   * @param {*} amount
   * @param {*} decimalCount
   * @param {*} decimal
   * @param {*} thousands
   * @returns
   */
  static formatMoney(amount, decimalCount = 2, decimal = '.', thousands = ',') {
    try {
      if (typeof amount !== 'number') {
        throw new Error(i18n.t('common_words.error_text'));
      }

      if (isNaN(amount)) return '';
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? '-' : '';
      const absoluteAmount = Math.abs(amount);
      const roundedAmount = absoluteAmount.toFixed(decimalCount);
      const integerPart = parseInt(roundedAmount).toString();
      const j = integerPart.length > 3 ? integerPart.length % 3 : 0;

      const formattedIntegerPart =
        (j ? integerPart.substr(0, j) + thousands : '') +
        integerPart.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands);

      const decimalPart =
        decimalCount > 0
          ? decimal +
          Math.abs(roundedAmount - integerPart)
            .toFixed(decimalCount)
            .slice(2)
          : '';

      const formattedAmount = negativeSign + formattedIntegerPart + decimalPart;

      return formattedAmount.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1');
    } catch (e) {
      console.log(e);
      return '';
    }
  }

  /**
   * Formatear números con formato en-EN y 2 dígitos decimales.
   * En caso de no ser undefined o NaN devuelve una string vacio
   * y en caso de no ser número devuelve el parámetro tal cual
   * es pasado en la función.
   * @param {*} value
   * @param {*} decimalCount
   * @returns
   */
  static formatNumber(value, decimalCount = 2) {
    if (isNaN(value)) return '';
    if (typeof value === 'number') {
      return new Intl.NumberFormat('en-EN', {
        minimumFractionDigits: decimalCount,
        maximumFractionDigits: decimalCount,
      })
        .format(value)
        .replace(/\.+0+$/, '');
    } else if (typeof value === 'undefined') {
      return '';
    } else {
      return value;
    }
  }

  /**
   * Formatea un número a forma de serie: 1 -> 0001
   * - str: La cadena que se desea rellenar.
   * - length: La longitud deseada de la cadena final.
   * - padChar: El carácter que se utilizará para rellenar la cadena.
   * - padSide (opcional): Indica si el relleno se debe agregar a la
   * izquierda (left) o a la derecha (right) de la cadena. El valor predeterminado es "left".
   * @param string str
   * @param int length
   * @param char padChar
   * @param string padSide
   * @returns
   */
  static strPad(str, length, padChar, padSide = 'left') {
    str = String(str);

    if (str.length >= length) {
      return str;
    }

    const padding = padChar.repeat(length - str.length);

    if (padSide === 'left') {
      return padding + str;
    } else if (padSide === 'right') {
      return str + padding;
    } else {
      throw new Error('Invalid padding side: ' + padSide);
    }
  }

  static dateFormat(date) {
    return  moment(date).format("YYYY-MM-DD");
  }
}

export default Formatter;
